import * as authService from '../services/auth'
import { getSessionId } from '../services/loggerClient/session'

const { REACT_APP_API_BASE_URL } = process.env

export const downloadContentPDF = (contentId) => {
  const token = authService.getAccessToken()
  const ssoToken = authService.getSSOToken()
  const sessionId = getSessionId()

  return fetch(`${REACT_APP_API_BASE_URL}/content/${contentId}/pdf/download`, {
    method: 'GET',
    headers: {
      Authorization: token,
      'x-sso-token': ssoToken,
      'x-session-id': sessionId,
    },
  })
}
